export default "__VITE_ASSET__Cfn6qFsM__"